// The map dialog's Hazards switch (the first row of the Maps sheet's More view), persisted per
// browser like the POI selections. On by default: a walker who has never touched it sees hazards.
//
// Storage can throw (private mode, blocked site data) or hold junk, so every
// read and write is guarded — the switch must still work for this page view.

export const HAZARDS_VISIBLE_STORAGE_KEY = 'hazardsVisible';

export interface KeyValueStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function defaultStorage(): KeyValueStorage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** The stored choice, or ON when nothing (readable) was stored. */
export function readHazardsVisible(storage: KeyValueStorage | null = defaultStorage()): boolean {
  try {
    const raw = storage?.getItem(HAZARDS_VISIBLE_STORAGE_KEY);
    if (raw === 'false') return false;
    return true;
  } catch {
    return true;
  }
}

/** Remembers the choice. Returns false when it couldn't be stored. */
export function writeHazardsVisible(enabled: boolean, storage: KeyValueStorage | null = defaultStorage()): boolean {
  try {
    if (!storage) return false;
    storage.setItem(HAZARDS_VISIBLE_STORAGE_KEY, enabled ? 'true' : 'false');
    return true;
  } catch {
    return false;
  }
}
